import  { createContext } from 'react'

const Context = createContext({})
export const AppProvider = Context.Provider
export const AppConsumer = Context.Consumer

export default Context;